var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.943,
    height: 25.44,
    viewBox: "0 0 44.943 25.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-password-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "eye-password-Rectangle_935",
    "data-name": "Rectangle 935",
    width: 44.943,
    height: 25.44,
    transform: "translate(0 -0.302)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-password-Group_1282",
    "data-name": "Group 1282",
    transform: "translate(0 0.302)",
    clipPath: "url(#eye-password-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-password-Path_205",
    "data-name": "Path 205",
    d: "M22.276,21.809a9.009,9.009,0,0,1-8.91-9.08,8.912,8.912,0,1,1,17.821,0,9,9,0,0,1-8.91,9.08M22.276,0C14.131,0,7.787,4.853,0,12.729c6.7,6.732,12.332,12.729,22.276,12.729s17.244-7.6,22.276-12.59C39.4,7.021,32.1,0,22.276,0",
    transform: "translate(0 -0.321)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-password-Path_206",
    "data-name": "Path 206",
    d: "M133.974,58.145a3.193,3.193,0,0,1,.756-2.058,4.73,4.73,0,0,0-.756-.06,5.3,5.3,0,1,0,5.2,5.3c0-.229-.02-.457-.04-.686a3.186,3.186,0,0,1-5.161-2.5Z",
    transform: "translate(-111.698 -48.919)",
    fill: "#aaa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePassword);
export default __webpack_public_path__ + "static/media/eye-password.93892336f11ba906c1ab957cebaa701a.svg";
export { ForwardRef as ReactComponent };